import { IWorkbenchSetting } from '@framework/workbench/setting/workbench-setting.interface';
import {
    IWorkbenchSettings,
    WorkbenchMenuSchema,
    WorkbenchTitlebarSchema,
    WorkbenchToolbarSchema,
} from '@tencent/workbench';
import {
    MODEL_THROTTLE_TIME,
    PLATFORM_PC,
    SELECTION_THROTTLE_TIME,
    TAKE_UP_SPACE_HEIGHT,
    TITLE_BAR_HEIGHT,
} from '@framework/workbench/const/pc-setting-const';
import { isPreviewDriveFile } from '@src/slide/infrastructure/module/dependent/runtime-environment/drive-env';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { ToolbarType } from '@src/js/constant';
import { FIXED_KEYS_DOUBLE, FIXED_KEYS_SINGLE } from '@framework/workbench/schema/constant';
import DocsConfig from '@tencent/docs-config';
import { FormExtension } from '@tencent/wb-ext-form';
import { getToggleStatusByType, ToggleType } from '@src/slide/infrastructure/module/dependent/config/toggle-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { UndoController } from '@framework/workbench/ui/undo/undo-controller';
import { RedoController } from '@framework/workbench/ui/redo/redo-controller';
import { BrushController } from '@framework/workbench/ui/brush/brush-controller';
import { ClearController } from '@framework/workbench/ui/clear/clear-controller';
import { InsertController } from '@framework/workbench/ui/insert/insert/insert-controller';
import { InsertTextController } from '@framework/workbench/ui/insert/insert-text/insert-text-controller';
import { InsertShapeController } from '@framework/workbench/ui/insert/insert-shape/insert-shape-controller';
import { InsertPictureController } from '@framework/workbench/ui/insert/insert-picture/insert-picture-controller';
import { InsertPictureController as InsertPictureControllerOld } from '@framework/workbench/ui/insert/insert-picture-old/insert-picture-controller';
import { InsertAudioController } from '@framework/workbench/ui/insert/insert-audio/insert-audio-controller';
import { InsertAudioController as InsertAudioControllerOld } from '@framework/workbench/ui/insert/insert-audio-old/insert-audio-controller';
import { InsertVideoController } from '@framework/workbench/ui/insert/insert-video/insert-video-controller';
import { InsertVideoController as InsertVideoControllerOld } from '@framework/workbench/ui/insert/insert-video-old/insert-video-controller';
import { InsertTableController } from '@framework/workbench/ui/insert/insert-table/insert-table-controller';
import { InsertLinkController } from '@framework/workbench/ui/insert/insert-link/insert-link-controller';
import { InsertFooterController } from '@framework/workbench/ui/insert/insert-footer/insert-footer-controller';
import { InsertChartController } from '@framework/workbench/ui/insert/insert-chart/insert-chart-controller';
import { ChartController } from '@framework/workbench/ui/chart/chart-controller';
import { InsertPlaceController } from '@framework/workbench/ui/insert-placeholder/insert-placeholder/insert-place-controller';
import { InsertLayoutController } from '@framework/workbench/ui/insert-placeholder/insert-layout/insert-layout-controller';
import { FontFamilyController } from '@framework/workbench/ui/font-family/font-family-controller';
import { FontSizeController } from '@framework/workbench/ui/font-size/font-size-controller';
import { FontSizeIncreaseController } from '@framework/workbench/ui/font-size-increase/font-size-increase-controller';
import { FontSizeDecreaseController } from '@framework/workbench/ui/font-size-decrease/font-size-decrease-controller';
import { BoldController } from '@framework/workbench/ui/bold/bold-controller';
import { ItalicController } from '@framework/workbench/ui/italic/italic-controller';
import { DeleteLineController } from '@framework/workbench/ui/delete-line/delete-line-controller';
import { UnderlineController } from '@framework/workbench/ui/underline/underline-controller';
import { SubscriptController } from '@framework/workbench/ui/subscript/subscript-controller';
import { SuperscriptController } from '@framework/workbench/ui/superscript/superscript-controller';
import { BackColorController } from '@framework/workbench/ui/back-color/back-color-controller';
import { ForeColorController } from '@framework/workbench/ui/fore-color/fore-color-controller';
import { ItemNumberController } from '@framework/workbench/ui/item-number/item-number-controller';
import { DigitNumberController } from '@framework/workbench/ui/digit-number/digit-number-controller';
import { HorizontalAlignController } from '@framework/workbench/ui/horizontal-align/horizontal-align-controller';
import { RowSpaceController } from '@framework/workbench/ui/row-space/row-space-controller';
import { ColumnsController } from '@framework/workbench/ui/columns/columns-controller';
import { VerticlaAlignController } from '@framework/workbench/ui/verticla-align/verticla-align-controller';
import { MoveItemController } from '@framework/workbench/ui/move/move-item/move-item-controller';
import { MoveUpController } from '@framework/workbench/ui/move/move-up/move-up-controller';
import { MoveTopController } from '@framework/workbench/ui/move/move-top/move-top-controller';
import { MoveDownController } from '@framework/workbench/ui/move/move-down/move-down-controller';
import { MoveBottomController } from '@framework/workbench/ui/move/move-bottom/move-bottom-controller';
import { SelectWindowController } from '@framework/workbench/ui/move/select-window/select-window-controller';
import { AlignController } from '@framework/workbench/ui/align/align/align-controller';
import { AlignHorizontalltLeftController } from '@framework/workbench/ui/align/align-horizontallt-left/align-horizontallt-left-controller';
import { AlignHorizontalltCenterController } from '@framework/workbench/ui/align/align-horizontallt-center/align-horizontallt-center-controller';
import { AlignHorizontalltRightController } from '@framework/workbench/ui/align/align-horizontallt-right/align-horizontallt-right-controller';
import { AlignVerticallyTopController } from '@framework/workbench/ui/align/align-vertically-top/align-vertically-top-controller';
import { AlignVerticallyCenterController } from '@framework/workbench/ui/align/align-vertically-center/align-vertically-center-controller';
import { AlignVerticallyBottomController } from '@framework/workbench/ui/align/align-vertically-bottom/align-vertically-bottom-controller';
import { AlignDistributeHorizontalltController } from '@framework/workbench/ui/align/align-distribute-horizontallt/align-distribute-horizontallt-controller';
import { AlignDistributeVerticallyController } from '@framework/workbench/ui/align/align-distribute-vertically/align-distribute-vertically-controller';
import { GroupController } from '@framework/workbench/ui/group/group/group-controller';
import { AddGroupController } from '@framework/workbench/ui/group/add-group/add-group-controller';
import { RemoveGroupController } from '@framework/workbench/ui/group/remove-group/remove-group-controller';
import { FillColorController } from '@framework/workbench/ui/fill-color/fill-color-controller';
import { BorderColorController } from '@framework/workbench/ui/border-color/border-color-controller';
import { InsertAnimationController } from '@framework/workbench/ui/insert-animation/insert-animation-controller';
import { PageSettingController } from '@framework/workbench/ui/page/page-setting/page-setting-controller';
import { ChangeThemeController } from '@framework/workbench/ui/quick-setting/change-theme/change-theme-controller';
import { ChangeTemplateController } from '@framework/workbench/ui/change-template/change-template-controller';
import { ChangeThemeTemplateMoreController } from '@framework/workbench/ui/change-theme-template-more/change-theme-template-more-controller';
import { ChangeThemeColorController } from '@framework/workbench/ui/change-theme-color/change-theme-color-controller';
import { ChangeBgController } from '@framework/workbench/ui/page/change-bg/change-bg-controller';
import { ChangeModelController } from '@framework/workbench/ui/page/master-layout-model/change-model-controller';
import { BorderStyleController } from '@framework/workbench/ui/border-style/border-style-controller';
import { MergeCellController } from '@framework/workbench/ui/merge-cell/merge-cell-controller';
import { TransparencyController } from '@framework/workbench/ui/transparency/transparency-controller';
import { TailorPicController } from '@framework/workbench/ui/tailor/tailor-pic/tailor-pic-controller';
import { SearchReplaceController } from '@framework/workbench/ui/search-replace/search-replace-controller';
import { ToggleController } from '@framework/workbench/ui/toggle/toggle-controller';
import { GenerateCopiesController } from '@framework/workbench/ui/generate-copies/generate-copies-controller';
import { SaveTempController } from '@framework/workbench/ui/save-temp/save-temp-controller';
import { RevisionRecordController } from '@framework/workbench/ui/revision-record/revision-record-controller';
import { ReadRecordController } from '@framework/workbench/ui/read-record/read-record-controller';
import { AccessibilityController } from '@framework/workbench/ui/accessibility/accessibility-controller';
import { HelpAndFeedbackController } from '@framework/workbench/ui/help-and-feedback/help-and-feedback-controller';
import { DevelopmentController } from '@framework/workbench/ui/development/development-controller';
import { SlideSizeController } from '@framework/workbench/ui/page/slide-size/slide-size-controller';
import { TailorPicWhController } from '@framework/workbench/ui/tailor/tailor-pic-wh/tailor-pic-wh-controller';
import { TextStyleController } from '@framework/workbench/ui/text-style/text-style-controller';
import { TextFormatController } from '@framework/workbench/ui/text-format/text-format-controller';
import { TypeSetController } from '@framework/workbench/ui/type-set/type-set-controller';
import { TableDetailController } from '@framework/workbench/ui/table-detail/table-detail-controller';
import { FormatPicController } from '@framework/workbench/ui/format-pic/format-pic-controller';
import { ShapeFormatController } from '@framework/workbench/ui/shape-format/shape-format-controller';
import { TextColorPaletteController } from '@framework/workbench/ui/palette/text-color-palette/text-color-palette-controller';
import { TextBackgroundPaletteController } from '@framework/workbench/ui/palette/text-background-palette/text-background-palette-controller';
import { FillColorPaletteController } from '@framework/workbench/ui/palette/fill-color-palette/fill-color-palette-controller';
import { BorderColorPaletteController } from '@framework/workbench/ui/palette/border-color-palette/border-color-palette-controller';
import { EffectController } from '@framework/workbench/ui/effect/effect-controller';
import { IndentationController } from '@framework/workbench/ui/indentation/indentation-controller';
import { FoldController } from '@framework/workbench/ui/fold/fold-controller';
import { CopyLinkController } from '@framework/workbench/ui/copy-link/copy-link-controller';
import { FontShadowController } from '@framework/workbench/drawer/ui/text/effects/shadow/shadow-controller';
import { FontReflectionController } from '@framework/workbench/drawer/ui/text/effects/reflection/reflection-controller';
import { FontGlowController } from '@framework/workbench/drawer/ui/text/effects/glow/glow-controller';
import { FontFillController } from '@framework/workbench/drawer/ui/text/fill/fill-controller';
import { FontBorderController } from '@framework/workbench/drawer/ui/text/border/border-controller';
import { RotateController } from '@framework/workbench/drawer/ui/layout/rotate/rotate-controller';
import { ThreeDController } from '@framework/workbench/drawer/ui/layout/3d/three-d-controller';
import { RegulateController } from '@framework/workbench/drawer/ui/picture/regulate/regulate-controller';
import { PictureColorController } from '@framework/workbench/drawer/ui/picture/picture-color/picture-color-controller';
import { ItemNumController } from '@framework/workbench/drawer/ui/text/paragraph/item-num/item-num-controller';
import { DigitNumController } from '@framework/workbench/drawer/ui/text/paragraph/digit-num/digit-num-controller';
import { FontFamilyFormController } from '@framework/workbench/drawer/ui/text/font/font-family/font-family-controller';
import { FormFontColorController } from '@framework/workbench/drawer/ui/text/font/font-color/font-color-controller';
import { FontSizeFormController } from '@framework/workbench/drawer/ui/text/font/font-size/font-size-controller';
import { BackColorFormController } from '@framework/workbench/drawer/ui/text/font/back-color/back-color-controller';
import { TextBoxController } from '@framework/workbench/drawer/ui/text/text-box/text-box-controller';
import { TableBorderController } from '@framework/workbench/drawer/ui/table/border/table-border-controller';
import { SizeController } from '@framework/workbench/drawer/ui/layout/size/size-controller';
import { TableBorderColorController } from '@framework/workbench/drawer/ui/table/border-color/table-border-color-controller';
import { FormSelectWindowController } from '@framework/workbench/drawer/ui/layout/select-window/select-window-controller';
import { AnimationController } from '@framework/workbench/drawer/ui/animation/animation-controller';
import { SlideFooterController } from '@framework/workbench/drawer/ui/slide-footer/slide-footer-controller';
import { PositionController } from '@framework/workbench/drawer/ui/layout/position/position-controller';
import { PictureCropController } from '@framework/workbench/drawer/ui/picture/picture-crop/picture-crop-controller';
import { PictureOpacityController } from '@framework/workbench/drawer/ui/picture/picture-opacity/picture-opacity-controller';
import { FontFamilyThemeFormController } from '@framework/workbench/drawer/ui/text/font/font-family-theme/font-family-theme-controller';
import { BackgroundController } from '@framework/workbench/drawer/components/background/bg-controller';
import { SlideSizeController as SlideSizeDrawerController } from '@framework/workbench/drawer/components/slide-size/slide-size-controller';
import { PlaceholderFormatController } from '@framework/workbench/drawer/components/placeholder-fomat/pl-format-controller';
import { LayoutChangeController } from '@framework/workbench/drawer/components/layout-change/layout-change-controller';
import { ChartDataEditorController } from '@framework/workbench/drawer/ui/chart/global-settings/chart-data/chart-data-editor-controller';
import { ChartFontFamilyController } from '@framework/workbench/drawer/ui/chart/common/font/font-family/font-family-controller';
import { ChartFontColorController } from '@framework/workbench/drawer/ui/chart/common/font/font-color/font-color-controller';
import { ChartFontSizeController } from '@framework/workbench/drawer/ui/chart/common/font/font-size/font-size-controller';
import { ChartFontStyleController } from '@framework/workbench/drawer/ui/chart/common/font/font-style/font-style-controller';
import { ChartLineController } from '@framework/workbench/drawer/ui/chart/common/line/line-controller';
import { ChartFillController } from '@framework/workbench/drawer/ui/chart/common/fill/fill-controller';
import { ChartFillGlobalController } from '@framework/workbench/drawer/ui/chart/global-settings/chart-fill/chart-fill-global-controller';
import { ChartGlobalLineController } from '@framework/workbench/drawer/ui/chart/global-settings/chart-line/chart-line-global-controller';
import { ChartGlobalShadowController } from '@framework/workbench/drawer/ui/chart/global-settings/chart-effect/chart-shadow/chart-shadow-controller';
import { ChartGlobalGlowController } from '@framework/workbench/drawer/ui/chart/global-settings/chart-effect/chart-glow/chart-glow-controller';
import { ChartGlobalSoftEdgeController } from '@framework/workbench/drawer/ui/chart/global-settings/chart-effect/chart-soft-edge/chart-soft-dege-controller';
import { RowColSizeController } from '@framework/workbench/drawer/ui/table/row-col-size/row-col-size-controller';
import { LocalPlayFromBeginController } from '@framework/workbench/ui/play/local-play-from-begin/local-play-from-begin-controller';
import { LocalPlayFromCurrentController } from '@framework/workbench/ui/play/local-play-from-current/local-play-from-current-controller';
import { LocalWithPresenterViewController } from '@framework/workbench/ui/play/local-with-presenter-view/local-with-presenter-view-controller';
import { MobileRemotePlayController } from '@framework/workbench/ui/play/mobile-remote-control/mobile-remote-control-controller';
import { RemotePlayController } from '@framework/workbench/ui/play/remote-play/remote-play-controller';
import { TencentMeetingPlayController } from '@framework/workbench/ui/play/tencent-meeting-play/tencent-meeting-play-controller';
import { InsertBlankSlideController } from '@framework/workbench/ui/insert/insert-blank-slide/insert-blank-slide-controller';
import { InsertTemplateSlideController } from '@framework/workbench/ui/insert/insert-template-slide/insert-template-slide-controller';
import { SingleToolbarMenuController } from '@framework/workbench/ui/single-menu/single-toolbar-menu-controller';
import { EditViewController } from '@framework/workbench/ui/view/edit-view/edit-view-controller';
import { MasterViewController } from '@framework/workbench/ui/view/master-view/master-view-controller';
import { NoteSwitchController } from '@framework/workbench/ui/note-switch/note-switch-controller';
import { AutoAdjustSlideController } from '@framework/workbench/ui/auto-adjust-slide/auto-adjust-slide-controller';
import { AdjustSlideController } from '@framework/workbench/ui/adjust-slide/adjust-slide-controller';
import { GridLineController } from '@framework/workbench/ui/grid-line/grid-line-controller';
import { GuideLineController } from '@framework/workbench/ui/guide-line/guide-line-controller';
import { SnapLineController } from '@framework/workbench/ui/snap-line/snap-line-controller';
import { TextRulerController } from '@framework/workbench/ui/text-ruler/text-ruler-controller';
import { AnimPreviewController } from '@framework/workbench/ui/anim-preview/anim-preview-controller';
import { AnimPaneController } from '@framework/workbench/ui/anim-pane/anim-pane-controller';
import { AnimEntrController } from '@framework/workbench/ui/anim-entr/anim-entr-controller';
import { AnimEmphController } from '@framework/workbench/ui/anim-emph/anim-emph-controller';
import { AnimExitController } from '@framework/workbench/ui/anim-exit/anim-exit-controller';
import { AnimStartController } from '@framework/workbench/ui/anim-start/anim-start-controller';
import { AnimDelayController } from '@framework/workbench/ui/anim-delay/anim-delay-controller';
import { AnimDurationController } from '@framework/workbench/ui/anim-duration/anim-duration-controller';
import { AnimTriggerController } from '@framework/workbench/ui/anim-trigger/anim-trigger-controller';
import { loadChartTypeSelectFeature } from '@framework/workbench/drawer/ui/chart/global-settings/chart-type-select/chart-type-select-feature-loader';
import { loadChartElementFeature } from '@framework/workbench/drawer/ui/chart/global-settings/chart-element/chart-element-feature-loader';
import { loadEnvConfigFeature } from '@framework/workbench/drawer/ui/chart/env-config/env-config-feature-loader';
import { loadChartLegendFeature } from '@framework/workbench/drawer/ui/chart/legend/chart-legend-feature-loader';
import { loadValueAxisFeature } from '@framework/workbench/drawer/ui/chart/axis/value-axis-feature-loader';
import { loadChartAxisTitleFeature, loadChartAxisTitleShower } from '@framework/workbench/drawer/ui/chart/axis/chart-axis-title-feature-loader';
import { CornerMarkController } from '@src/framework/workbench/ui/anim-corner-mark/anim-corner-mark-controller';
import { loadChartDataLabelFeature } from '@framework/workbench/drawer/ui/chart/data-label/chart-data-label-feature-loader';
import { loadChartDataLabelFormatFeature } from '@framework/workbench/drawer/ui/chart/data-label/chart-data-label-format-feature-loader';
import { loadChartLineMarkerSeletorFeature } from '@framework/workbench/drawer/ui/chart/geometry/line-marker-selector/line-marker-selector-feature-loader';
import { loadMarkerOptionsFeature } from '@framework/workbench/drawer/ui/chart/geometry/marker-options/marker-options-feature-loader';
import { loadChartThemeColorFeature } from '@framework/workbench/drawer/ui/chart/global-settings/chart-theme-color/chart-theme-color-feature-loader';
import { loadSeriesOptionsFeature } from '@framework/workbench/drawer/ui/chart/geometry/series-options/series-options-feature-loader';
import { loadSeriesOptionsShower } from '@framework/workbench/drawer/ui/chart/geometry/series-options/series-options-shower-loader';
import { slideFormSchema } from '@framework/workbench/schema/form';
import { BatchHandleAnimationController } from '@framework/workbench/ui/batch-handle-animation/batch-handle-animation-controller';
import { loadChartTypeSelectShower } from '@framework/workbench/drawer/ui/chart/global-settings/chart-type-select/chart-type-select-shower-loader';
import { loadChartElementShower } from '@framework/workbench/drawer/ui/chart/global-settings/chart-element/chart-element-shower-loader';
import { loadChartLegendShower } from '@framework/workbench/drawer/ui/chart/legend/chart-legend-shower-loader';
import { loadValueAxisShower } from '@framework/workbench/drawer/ui/chart/axis/value-axis-shower-loader';
import { loadChartDataLabelShower } from '@framework/workbench/drawer/ui/chart/data-label/chart-data-label-shower-loader';
import { loadChartDataLabelFormatShower } from '@framework/workbench/drawer/ui/chart/data-label/chart-data-label-format-shower-loader';
import { loadChartThemeColorShower } from '@framework/workbench/drawer/ui/chart/global-settings/chart-theme-color/chart-theme-color-shower-loader';
import { loadChartAxisTypeSelsectShower } from '@framework/workbench/drawer/ui/chart/axis/chart-axis-type-select-shower-loader';
import { VipServiceController } from '@src/framework/workbench/ui/vip-service/vip-service-controller';
import { OCRPictureController } from '@framework/workbench/ui/quick-setting/ocr-picture/ocr-picture-controller';
import { ReplacePictureController } from '@src/framework/workbench/ui/picture/picture-replace/replace-picture-controller';
import { ResetPictureController } from '@src/framework/workbench/ui/picture/picture-reset/reset-picture-controller';
import { PictureCorrectionsController } from '@src/framework/workbench/ui/picture/picture-corrections/picture-corrections-controller';
import { PictureColorController as PictureColorToolbarController } from '@src/framework/workbench/ui/picture/picture-color/picture-color-controller';
import { PictureTransparencyController } from '@src/framework/workbench/ui/picture/picture-transparency/picture-transparency-controller';
import { RotateController as ToolbarRotateController } from '@src/framework/workbench/ui/rotate/rotate-controller';
import { TailorPicShapeController } from '@src/framework/workbench/ui/tailor/tailor-pic-shape/tailor-pic-shape-controller';
import { PictureFastStyleController } from '@src/framework/workbench/ui/picture/picture-fast-style/picture-fast-style-controller';
import { SizeWithRatioController } from '@src/framework/workbench/ui/size-with-ratio/size-with-ratio-controller';
import { PictureTabController } from '@src/framework/workbench/ui/picture/picture-tab/picture-tab-controller';

import { TransitionChangeController } from '@framework/workbench/ui/transition/transition-change/transition-change-controller';
import { TransitionPreviewController } from '@framework/workbench/ui/transition/transition-preview/transition-preview-controller';
import { TransitionApplyAllController } from '@framework/workbench/ui/transition/transition-apply-all/transition-apply-all-controller';
import { TransitionEffectOptionController } from '@framework/workbench/ui/transition/transition-effect-option/transition-effect-option-controller';
import { TransitionDurationController } from '@framework/workbench/ui/transition/transition-duration/transition-duration-controller';
import {
    TransitionChangeSimpleController,
} from '@framework/workbench/ui/transition/simple/transition-change-simple/transition-change-simple.controller';
import { ShapeFastStyleController } from '@src/framework/workbench/ui/shape/shape-fast-style/shape-fast-style-controller';
import { TextFastStyleController } from '@src/framework/workbench/ui/shape/text-fast-style/text-fast-style-controller';
import { ShapeTabController } from '@src/framework/workbench/ui/shape/shape-tab/shape-tab-controller';
import { AnimBrushController } from '../../ui/anim-brush/anim-brush-controller';
import { loadSolidFillFeature, loadSolidFillShower } from '@framework/workbench/drawer/ui/fill/solid-fill/solid-fill-loader';
import { loadGradualFillShower, loadGradualFillFeature } from '@framework/workbench/drawer/ui/fill/gradual-fill/gradual-fill-loader';
import { loadImageFillShower, loadImageFillFeature } from '@framework/workbench/drawer/ui/fill/image-fill/image-fill-loader';
import { loadFillTypeFeature, loadFillTypeShower } from '@framework/workbench/drawer/ui/fill/fill-type/fill-type-loader';
import { loadBackgroundFillShower, loadBackgroundFillFeature } from '@framework/workbench/drawer/ui/fill/background-fill/background-fill-loader';
import { loadBorderFeature, loadBorderShower } from '@framework/workbench/drawer/ui/border/load-border-feature';
import { loadGlowFeature, loadGlowShower } from '@framework/workbench/drawer/ui/effects/glow/glow-feature-loader';
import { loadSoftEdgeFeature, loadSoftEdgeShower } from '@framework/workbench/drawer/ui/effects/soft-edge/soft-edge-feature-loader';
import { loadShadowFeature, loadShadowShower } from '@framework/workbench/drawer/ui/effects/shadow/shadow-feature-loader';
import { loadReflectionFeature, loadReflectionShower } from '@framework/workbench/drawer/ui/effects/reflection/reflection-feature-loader';
import { FileMenuController } from '@tencent/docs-titlebar-service';
import { PcTopMenuController } from '@src/framework/workbench/ui/pc-top-menu/pc-top-menu-controller';
import { ExitMasterEditController } from '@src/framework/workbench/ui/insert-placeholder/exit-master-edit/exit-master-edit-controller';
import { RenameController } from '@src/framework/workbench/ui/rename/rename-controller';
import { DocPersonalizationController } from '@framework/workbench/ui/doc-personalization/doc-personalization-controller';
import { ImagesJointController } from '@framework/workbench/ui/images-joint/images-joint-controller';
import { AiGeneratePageController } from '@framework/workbench/ui/ai-generate-page/ai-generate-page-controller';

/**
 * PC workbench配置项管理基类，主要用于生成PC的workbench配置。
 */
export default abstract class BasePcWorkbenchSetting implements IWorkbenchSetting {
    public createSettings(): IWorkbenchSettings<'pc'> {
        const appConfigInstance = DocsConfig.getInstance();
        return {
            platform: PLATFORM_PC,
            menu: { schema: this.getMenuSchema() },
            toolbar: {
                schema: this.getToolBarSchema(),
                fixedKeys: this.getInitialFixedKeys(),
                pinnedKey: 'toolbar-pinned',
                schemaAnimation: true,
                disabled: !appConfigInstance.getConfig('toolbar') || isPreviewDriveFile(),
            },
            mount: {
                extensions: [FormExtension],
                controllers: this.getController(),
                services: this.getServices(),
                features: this.getFeatures(),
            },
            contextMenu: {
                disabled: true,
            },
            titlebar: {
                schema: this.getTitleBarSchema(),
                height: TITLE_BAR_HEIGHT,
                hoverable: {
                    takeUpSpace: false,
                    takeUpSpaceHeight: TAKE_UP_SPACE_HEIGHT,
                },
                disabled: !appConfigInstance.getConfig('titlebar') || isPreviewDriveFile(),
            },
            statusbar: {
                disabled: true,
            },
            selectionThrottleTime: SELECTION_THROTTLE_TIME,
            modelThrottleTime: MODEL_THROTTLE_TIME,
            accessibility: { dropdownAutoFocus: false, menuClickFocus: false },
            form: {
                schema: slideFormSchema,
            },
        };
    }

    /**
     * 获取workbench的所有通用ui controller。
     * 子类可以扩展
     * @protected
     */
    protected getController(): Function[] {
        const insertNewPictureAudioVideo = getToggleStatusByType(ToggleType.TDOCS_PICTURE_AUDIO_AND_VIDEO_SWITCH, true)
            && (DocsConfig.getInstance().getConfig(ToolbarFileMenuConfig.insertNewPictureAudioVideo) ?? false);

        return [
            UndoController,
            RedoController,
            BrushController,
            ClearController,
            InsertController,
            InsertTextController,
            InsertShapeController,
            insertNewPictureAudioVideo ? InsertPictureController : InsertPictureControllerOld,
            insertNewPictureAudioVideo ? InsertAudioController : InsertAudioControllerOld,
            insertNewPictureAudioVideo ? InsertVideoController : InsertVideoControllerOld,
            InsertTableController,
            InsertLinkController,
            InsertFooterController,
            InsertChartController,
            ChartController,
            InsertPlaceController,
            InsertLayoutController,
            FontFamilyController,
            FontSizeController,
            FontSizeIncreaseController,
            FontSizeDecreaseController,
            BoldController,
            ItalicController,
            DeleteLineController,
            UnderlineController,
            SubscriptController,
            SuperscriptController,
            BackColorController,
            ForeColorController,
            ItemNumberController,
            DigitNumberController,
            HorizontalAlignController,
            RowSpaceController,
            ColumnsController,
            VerticlaAlignController,
            MoveItemController,
            MoveUpController,
            MoveTopController,
            MoveDownController,
            MoveBottomController,
            SelectWindowController,
            AlignController,
            AlignHorizontalltLeftController,
            AlignHorizontalltCenterController,
            AlignHorizontalltRightController,
            AlignVerticallyTopController,
            AlignVerticallyCenterController,
            AlignVerticallyBottomController,
            AlignDistributeHorizontalltController,
            AlignDistributeVerticallyController,
            GroupController,
            AddGroupController,
            RemoveGroupController,
            FillColorController,
            BorderColorController,
            InsertAnimationController,
            PageSettingController,
            ChangeThemeController,
            ChangeTemplateController,
            ChangeThemeTemplateMoreController,
            ChangeThemeColorController,
            TransitionChangeController,
            TransitionPreviewController,
            TransitionEffectOptionController,
            TransitionApplyAllController,
            TransitionDurationController,
            TransitionChangeSimpleController,
            ChangeBgController,
            ChangeModelController,
            BorderStyleController,
            MergeCellController,
            TransparencyController,
            TailorPicController,
            SearchReplaceController,
            ToggleController,
            GenerateCopiesController,
            SaveTempController,
            RevisionRecordController,
            ReadRecordController,
            AccessibilityController,
            HelpAndFeedbackController,
            DevelopmentController,
            SlideSizeController,
            TailorPicWhController,
            TextStyleController,
            TextFormatController,
            TypeSetController,
            TableDetailController,
            FormatPicController,
            ShapeFormatController,
            TextColorPaletteController,
            TextBackgroundPaletteController,
            FillColorPaletteController,
            BorderColorPaletteController,
            EffectController,
            IndentationController,
            FoldController,
            CopyLinkController,
            AiGeneratePageController,
            /** 侧边栏 */
            FontShadowController,
            FontReflectionController,
            FontGlowController,
            FontFillController,
            FontBorderController,
            RotateController,
            ThreeDController,
            RegulateController,
            PictureColorController,
            ItemNumController,
            DigitNumController,
            FontFamilyFormController,
            FormFontColorController,
            FontSizeFormController,
            BackColorFormController,
            TextBoxController,
            TableBorderController,
            SizeController,
            TableBorderColorController,
            FormSelectWindowController,
            AnimationController,
            SlideFooterController,
            PositionController,
            PictureCropController,
            PictureOpacityController,
            /** 母版编辑侧边栏 */
            FontFamilyThemeFormController,
            BackgroundController,
            SlideSizeDrawerController,
            PlaceholderFormatController,
            LayoutChangeController,
            ChartDataEditorController,
            ChartFontFamilyController,
            ChartFontColorController,
            ChartFontSizeController,
            ChartFontStyleController,
            ChartLineController,
            ChartFillController,
            ChartFillGlobalController, // 图表全局填充
            ChartGlobalLineController, // 图表全局边框
            ChartGlobalShadowController, // 图表全局阴影
            ChartGlobalGlowController, // 图表全局发光
            ChartGlobalSoftEdgeController, // 图表全局边缘柔化
            RowColSizeController,
            LocalPlayFromBeginController,
            LocalPlayFromCurrentController,
            LocalWithPresenterViewController,
            MobileRemotePlayController,
            RemotePlayController,
            TencentMeetingPlayController,
            InsertBlankSlideController,
            InsertTemplateSlideController,
            SingleToolbarMenuController,
            EditViewController,
            MasterViewController,
            NoteSwitchController,
            AutoAdjustSlideController,
            AdjustSlideController,
            GridLineController,
            GuideLineController,
            SnapLineController,
            TextRulerController,
            AnimPreviewController,
            AnimPaneController,
            AnimEntrController,
            AnimEmphController,
            AnimExitController,
            AnimStartController,
            AnimDelayController,
            AnimDurationController,
            AnimTriggerController,
            ShapeTabController,
            CornerMarkController,
            ReplacePictureController,
            ResetPictureController,
            PictureCorrectionsController,
            PictureColorToolbarController,
            PictureTransparencyController,
            ToolbarRotateController,
            TailorPicShapeController,
            PictureFastStyleController,
            SizeWithRatioController,
            BatchHandleAnimationController,
            AnimBrushController,
            VipServiceController,
            OCRPictureController,
            PictureTabController,
            PcTopMenuController,
            ...FileMenuController,
            ExitMasterEditController,
            ShapeFastStyleController,
            TextFastStyleController,
            RenameController,
            ImagesJointController,
            DocPersonalizationController,
        ].filter(Boolean) as Function[];
    }

    protected getServices(): Function[] {
        return [];
    }

    /**
     * 声明使用到的feature
     * @protected
     */
    protected getFeatures(): Function[] {
        loadSeriesOptionsFeature();
        loadSeriesOptionsShower();
        loadChartTypeSelectFeature();
        loadChartTypeSelectShower();
        loadChartElementFeature();
        loadChartElementShower();
        loadEnvConfigFeature();
        loadChartLegendFeature();
        loadChartLegendShower();
        loadValueAxisFeature();
        loadValueAxisShower();
        loadChartAxisTypeSelsectShower();
        loadChartAxisTitleFeature();
        loadChartAxisTitleShower();
        loadChartDataLabelFeature();
        loadChartDataLabelShower();
        loadChartDataLabelFormatFeature();
        loadChartDataLabelFormatShower();
        loadChartLineMarkerSeletorFeature();
        loadMarkerOptionsFeature();
        loadChartThemeColorFeature();
        loadChartThemeColorShower();
        loadSolidFillFeature();
        loadSolidFillShower();
        loadGradualFillShower();
        loadGradualFillFeature();
        loadImageFillFeature();
        loadImageFillShower();
        loadFillTypeFeature();
        loadFillTypeShower();
        loadBackgroundFillFeature();
        loadBackgroundFillShower();
        loadBorderFeature();
        loadBorderShower();
        loadGlowFeature();
        loadGlowShower();
        loadSoftEdgeFeature();
        loadSoftEdgeShower();
        loadShadowFeature();
        loadShadowShower();
        loadReflectionFeature();
        loadReflectionShower();
        return [];
    }

    private getInitialFixedKeys() {
        // 读取缓存的工具栏模式
        const toolbarMode = (
            AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices
        ).viewableServiceLayer.toolbarStateManager.getToolbarMode();
        let fixedKeys: string | string[];
        if (toolbarMode === ToolbarType.DOUBLE_TOOLBAR) {
            fixedKeys = Object.values(FIXED_KEYS_DOUBLE);
        } else {
            fixedKeys = FIXED_KEYS_SINGLE;
        }
        return fixedKeys;
    }

    /**
     * 获取menu schema，子类实现
     * @protected
     */
    protected abstract getMenuSchema(): WorkbenchMenuSchema;

    /**
     * 获取tool bar schema，子类实现
     * @protected
     */
    protected abstract getToolBarSchema(): WorkbenchToolbarSchema;

    /**
     * 获取titlebar schema，子类实现
     * @protected
     */
    protected abstract getTitleBarSchema(): WorkbenchTitlebarSchema;
}
